import React, { useState } from 'react';
import { Typography, Button, CircularProgress, Grid } from '@mui/material';
import { initiateMyLoginAuth } from '../../../utils/myLoginAuth';
import paths from '../../../routes/paths';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { iconMyLogin } from '../../assets/images';

const MyLoginForm = ({ onBackClick }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleMyLogin = async () => {
    try {
      setLoading(true);
      setError(null);
      localStorage.setItem('auth_redirect_url', paths.pupilSurveys);
      await initiateMyLoginAuth(paths.pupilSurveys);
    } catch {
      setError('MyLogin authentication failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Grid container justifyContent="center">
      <Grid item lg={6} md={6} sm={11} xs={11}>
        <div className="formHeader">
          <div className="iconContainer">
            <img src={iconMyLogin} alt="" />
          </div>
          <h2 className="formTitle">
            Login with MyLogin
          </h2>
        </div>
        {error && <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>}
        <Button
          variant="contained"
          onClick={handleMyLogin}
          //startIcon={loading && <CircularProgress size={20} color="inherit" />}
          disabled={loading}
          className="mylogin-btn"
          disableElevation
          disableRipple
        >
          {loading ? 'Connecting...' : 'Sign in with MyLogin'}
        </Button>

        <Button fullWidth variant="text" onClick={onBackClick} className="backButton" startIcon={<KeyboardBackspaceIcon />} disableRipple>
          Back to Login Options
        </Button>
      </Grid>
    </Grid>
  );
};

export default MyLoginForm;
